import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_file_transfer_pushService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { service_endpoint: string, container_name: string, folder: string, authentication: { st: string, se: string, sv: string, sig: string }, files?: { name?: string, content?: any }[] }): Promise<{ messages?: any[], success?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.service_endpoint)) {
      missingRequiredInParams.push('\'service_endpoint\'');
    }
    if (isNil(inParams.container_name)) {
      missingRequiredInParams.push('\'container_name\'');
    }
    if (isNil(inParams.folder)) {
      missingRequiredInParams.push('\'folder\'');
    }
    if (isNil(inParams.authentication)) {
      missingRequiredInParams.push('\'authentication\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

